export enum FieldId {
  PLAN_HOLDER_CONTACT_CELLPHONE_NUMBER = 'PLAN_HOLDER_CONTACT_CELLPHONE_NUMBER',
  PLAN_HOLDER_CONTACT_EMAIL = 'PLAN_HOLDER_CONTACT_EMAIL',
  PLAN_HOLDER_INITIALS = 'PLAN_HOLDER_INITIALS',
  PLAN_HOLDER_MARITAL_STATUS = 'PLAN_HOLDER_MARITAL_STATUS',
  PLAN_HOLDER_OCCUPATION = 'PLAN_HOLDER_OCCUPATION',
  PLAN_HOLDER_INSURANCE_CANCELLED = 'PLAN_HOLDER_INSURANCE_CANCELLED',
  PLAN_HOLDER_TITLE = 'PLAN_HOLDER_TITLE',
  PLAN_HOLDER_YEARS_PREVIOUS_INSURER = 'PLAN_HOLDER_YEARS_PREVIOUS_INSURER',
  PLAN_HOLDER_NUMBER_OF_CLAIMS = 'PLAN_HOLDER_NUMBER_OF_CLAIMS',
  LICENSE_DETAILS_LICENSE_NUMBER = 'LICENSE_DETAILS_LICENSE_NUMBER',
  LICENSE_DETAILS_LICENSE_TYPE = 'LICENSE_DETAILS_LICENSE_TYPE',
  LICENSE_DETAILS_FIRST_YEAR_OF_ISSUE = 'LICENSE_DETAILS_FIRST_YEAR_OF_ISSUE',
  PRIMARY_DRIVER_CONTACT_CELLPHONE_NUMBER = 'PRIMARY_DRIVER_CONTACT_CELLPHONE_NUMBER',
  PRIMARY_DRIVER_CONTACT_EMAIL = 'PRIMARY_DRIVER_CONTACT_EMAIL',
  PRIMARY_DRIVER_INITIALS = 'PRIMARY_DRIVER_INITIALS',
  PRIMARY_DRIVER_MARITAL_STATUS = 'PRIMARY_DRIVER_MARITAL_STATUS',
  PRIMARY_DRIVER_OCCUPATION = 'PRIMARY_DRIVER_OCCUPATION',
  PRIMARY_DRIVER_YEARS_PREVIOUS_INSURER = 'PRIMARY_DRIVER_YEARS_PREVIOUS_INSURER',
  PRIMARY_DRIVER_TITLE = 'PRIMARY_DRIVER_TITLE',
  PRIMARY_DRIVER_NUMBER_OF_CLAIMS = 'PRIMARY_DRIVER_NUMBER_OF_CLAIMS',
  PRIMARY_DRIVER_LICENSE_DETAILS_LICENSE_NUMBER = 'PRIMARY_DRIVER_LICENSE_DETAILS_LICENSE_NUMBER',
  PRIMARY_DRIVER_LICENSE_DETAILS_LICENSE_TYPE = 'PRIMARY_DRIVER_LICENSE_DETAILS_LICENSE_TYPE',
  PRIMARY_DRIVER_LICENSE_DETAILS_FIRST_YEAR_OF_ISSUE = 'PRIMARY_DRIVER_LICENSE_DETAILS_FIRST_YEAR_OF_ISSUE',
  VEHICLE_AND_OWNER_PARTICULARS = 'VEHICLE_AND_OWNER_PARTICULARS',
  REGISTERED_OWNER = 'REGISTERED_OWNER',
  ADDRESS_DETAILS = 'ADDRESS_DETAILS',
  VEHICLE_MODIFICATIONS = 'VEHICLE_MODIFICATIONS',
  VEHICLE_EXTRAS = 'VEHICLE_EXTRAS',
  VEHICLE_AND_OWNER_PARTICULARS_REGISTERED_OWNER = 'VEHICLE_AND_OWNER_PARTICULARS_REGISTERED_OWNER',
  VEHICLE_AND_OWNER_PARTICULARS_BRAND_NEW_INDICATOR = 'VEHICLE_AND_OWNER_PARTICULARS_BRAND_NEW_INDICATOR',
  VEHICLE_AND_OWNER_PARTICULARS_COLOUR = 'VEHICLE_AND_OWNER_PARTICULARS_COLOUR',
  VEHICLE_AND_OWNER_PARTICULARS_ENGINE_NUMBER = 'VEHICLE_AND_OWNER_PARTICULARS_ENGINE_NUMBER',
  VEHICLE_AND_OWNER_PARTICULARS_MAIN_USE = 'VEHICLE_AND_OWNER_PARTICULARS_MAIN_USE',
  VEHICLE_AND_OWNER_PARTICULARS_VEHICLE_FINANCING = 'VEHICLE_AND_OWNER_PARTICULARS_VEHICLE_FINANCING',
  VEHICLE_AND_OWNER_PARTICULARS_INSURED_TYPE = 'VEHICLE_AND_OWNER_PARTICULARS_INSURED_TYPE',
  VEHICLE_AND_OWNER_PARTICULARS_INSURED_AMOUNT = 'VEHICLE_AND_OWNER_PARTICULARS_INSURED_AMOUNT',
  VEHICLE_AND_OWNER_PARTICULARS_REGISTRATION_NUMBER = 'VEHICLE_AND_OWNER_PARTICULARS_REGISTRATION_NUMBER',
  VEHICLE_AND_OWNER_PARTICULARS_VIN = 'VEHICLE_AND_OWNER_PARTICULARS_VIN',
  REGISTERED_OWNER_TITLE = 'REGISTERED_OWNER_TITLE',
  REGISTERED_OWNER_NAME = 'REGISTERED_OWNER_NAME',
  REGISTERED_OWNER_INITIALS = 'REGISTERED_OWNER_INITIALS',
  REGISTERED_OWNER_SURNAME = 'REGISTERED_OWNER_SURNAME',
  REGISTERED_OWNER_IDENTIFICATION_TYPE = 'REGISTERED_OWNER_IDENTIFICATION_TYPE',
  REGISTERED_OWNER_ID_NUMBER = 'REGISTERED_OWNER_ID_NUMBER',
  REGISTERED_OWNER_PASSPORT_NUMBER = 'REGISTERED_OWNER_PASSPORT_NUMBER',
  REGISTERED_OWNER_DATE_OF_BIRTH = 'REGISTERED_OWNER_DATE_OF_BIRTH',
  REGISTERED_OWNER_GENDER = 'REGISTERED_OWNER_GENDER',
  ADDRESS_DETAILS_NIGHT_TIME_ADDRESS_TYPE = 'ADDRESS_DETAILS_NIGHT_TIME_ADDRESS_TYPE',
  ADDRESS_DETAILS_NIGHT_TIME_STREET_NUMBER = 'ADDRESS_DETAILS_NIGHT_TIME_STREET_NUMBER',
  ADDRESS_DETAILS_NIGHT_TIME_STREET_NAME = 'ADDRESS_DETAILS_NIGHT_TIME_STREET_NAME',
  ADDRESS_DETAILS_NIGHT_TIME_UNIT_COMPLEX_NUMBER = 'ADDRESS_DETAILS_NIGHT_TIME_UNIT_COMPLEX_NUMBER',
  ADDRESS_DETAILS_NIGHT_TIME_UNIT_COMPLEX_NAME = 'ADDRESS_DETAILS_NIGHT_TIME_UNIT_COMPLEX_NAME',
  ADDRESS_DETAILS_NIGHT_TIME_SECURITY = 'ADDRESS_DETAILS_NIGHT_TIME_SECURITY',
  ADDRESS_DETAILS_NIGHT_TIME_SUBURB = 'ADDRESS_DETAILS_NIGHT_TIME_SUBURB',
  ADDRESS_DETAILS_DAY_TIME_ADDRESS_TYPE = 'ADDRESS_DETAILS_DAY_TIME_ADDRESS_TYPE',
  ADDRESS_DETAILS_DAY_TIME_STREET_NUMBER = 'ADDRESS_DETAILS_DAY_TIME_STREET_NUMBER',
  ADDRESS_DETAILS_DAY_TIME_STREET_NAME = 'ADDRESS_DETAILS_DAY_TIME_STREET_NAME',
  ADDRESS_DETAILS_DAY_TIME_UNIT_COMPLEX_NUMBER = 'ADDRESS_DETAILS_DAY_TIME_UNIT_COMPLEX_NUMBER',
  ADDRESS_DETAILS_DAY_TIME_UNIT_COMPLEX_NAME = 'ADDRESS_DETAILS_DAY_TIME_UNIT_COMPLEX_NAME',
  ADDRESS_DETAILS_DAY_TIME_SECURITY = 'ADDRESS_DETAILS_DAY_TIME_SECURITY',
  ADDRESS_DETAILS_DAY_TIME_SUBURB = 'ADDRESS_DETAILS_DAY_TIME_SUBURB',
  BANKING_DETAILS_ACCOUNT_NUMBER = 'BANKING_DETAILS_ACCOUNT_NUMBER',
  BANKING_DETAILS_PREMIUM_DEDUCTION_DATE = 'BANKING_DETAILS_PREMIUM_DEDUCTION_DATE',
  BANKING_DETAILS_ACCOUNT_HOLDER_NAME = 'BANKING_DETAILS_ACCOUNT_HOLDER_NAME',
  BANKING_DETAILS_ACCOUNT_HOLDER_SURNAME = 'BANKING_DETAILS_ACCOUNT_HOLDER_SURNAME'
}
